import React from 'react';
import { X } from 'lucide-react';

export interface ShortcutGroup {
  title: string;
  items: Array<[keys: string, label: string]>;
}

const DEFAULT_GROUPS: ShortcutGroup[] = [
  {
    title: 'Playback',
    items: [
      ['Space / K', 'Play / Pause'],
      ['J / L', 'Skip ±10s'],
      ['← / →', 'Skip ±5s'],
      ['0–9', 'Jump to %'],
    ],
  },
  {
    title: 'Audio & captions',
    items: [
      ['M', 'Mute'],
      ['↑ / ↓', 'Volume ±10%'],
      ['C', 'Captions'],
    ],
  },
  {
    title: 'View',
    items: [
      ['F', 'Fullscreen'],
      ['I', 'Picture-in-picture'],
      ['Esc', 'Exit'],
    ],
  },
  {
    title: 'Speed & quality',
    items: [
      ['Shift +', 'Speed up'],
      ['Shift -', 'Slow down'],
      ['Q', 'Quality menu'],
    ],
  },
];

interface OdenShortcutsProps {
  open: boolean;
  groups?: ShortcutGroup[];
  onClose: () => void;
}

const OdenShortcuts: React.FC<OdenShortcutsProps> = ({ open, groups = DEFAULT_GROUPS, onClose }) => {
  if (!open) return null;
  return (
    <div
      className="absolute inset-0 z-40 flex items-center justify-center p-6 pointer-events-none"
      aria-hidden={!open}
    >
      <div
        role="dialog"
        aria-label="Keyboard shortcuts"
        className="oden-shortcuts pointer-events-auto"
        style={{ width: 'min(640px, 100%)', maxHeight: 'min(440px, 100%)' }}
      >
        <div className="oden-shortcuts-hd">
          <div>
            <div className="oden-shortcuts-eyebrow">Player</div>
            <div className="oden-shortcuts-title">Keyboard shortcuts</div>
          </div>
          <button type="button" className="oden-shortcuts-x" onClick={onClose} aria-label="Close">
            <span style={{ width: 18, height: 18, display: 'inline-flex' }}>
              <X size={18} />
            </span>
          </button>
        </div>
        <div className="oden-shortcuts-grid">
          {groups.map((g) => (
            <div key={g.title} className="oden-shortcuts-group">
              <div className="oden-shortcuts-group-title">{g.title}</div>
              {g.items.map(([k, v]) => (
                <div key={k} className="oden-shortcuts-row">
                  <kbd className="oden-shortcuts-kbd">{k}</kbd>
                  <span>{v}</span>
                </div>
              ))}
            </div>
          ))}
        </div>
        <div className="oden-shortcuts-foot">
          Press <kbd className="oden-shortcuts-kbd">?</kbd> anytime to toggle
        </div>
      </div>
    </div>
  );
};

export default OdenShortcuts;
